// extracted by mini-css-extract-plugin
export default {"ourBusiness":"BusinessHome_ourBusiness__Y9L+m","business":"BusinessHome_business__wIVuM"};